// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"PaginationBar_paginationWrapper__oguuO","page":"PaginationBar_page__gFts4","icon":"PaginationBar_icon__gB4Sp","disabled":"PaginationBar_disabled__WkCfp"};